export default __webpack_public_path__ + "static/media/spinner.b7028800.svg";